import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircle';
import { Alert, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import {
  cancel,
  billingTexts,
  stripeStatusTrial
} from 'src/common/config/TextMessage';
import { RootState } from 'src/redux/store';

export default function CancelSubscription({
  handCloseModal,
  handleCancelSubscription,
  loading,
  subscriptionCancelMessage
}) {
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );

  const isTrail = stripeSubscriptionDetails?.status === stripeStatusTrial;
  return (
    <div>
      <div>{billingTexts?.cancelSubscriptionWarning}</div>

      <div className="mt-2">
        {isTrail
          ? 'Note: The subscription will be immediately cancelled during the trial period.'
          : 'Note: The subscription will remain active till the end of billing period.'}
      </div>
      {subscriptionCancelMessage !== undefined ? (
        <Alert
          icon={
            <CheckCircleOutlineIcon
              fontSize="inherit"
              sx={{ color: 'var(--color-secondary)' }}
            />
          }
          severity="success"
        >
          {subscriptionCancelMessage}
        </Alert>
      ) : (
        ''
      )}

      <div className="flex space-x-5 mb-5 mt-5 justify-end h-10">
        <Button
          variant="contained"
          size="small"
          disabled={loading}
          onClick={() => {
            handleCancelSubscription();
          }}
        >
          {'Proceed'}
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            handCloseModal();
          }}
          sx={{ boxShadow: 'none !important' }}
        >
          {cancel}
        </Button>
      </div>
    </div>
  );
}
